import { Component, Input, OnInit, ViewContainerRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { FullCalendarModule } from '@fullcalendar/angular';
import { CalendarOptions } from '@fullcalendar/core'; // useful for typechecking
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { NbButtonModule, NbCardModule, NbDialogService, NbIconComponent, NbInputModule } from '@nebular/theme';
import { CalendarDialogComponent } from './calendar-dialog/calendar-dialog.component';
import { ConfigurationService } from '@urbannex/configuration';
/**
 * "FACEB_PROD_POST"/>
	 <WorkEffortType description="X(Twitter) Product Post" hasTable="N" parentTypeId="SOCIAL_MEDIA_POST" workEffortTypeId="X_PROD_POST"/>
	 <WorkEffortType description="Instagram Product Post" hasTable="N" parentTypeId="SOCIAL_MEDIA_POST" workEffortTypeId="INSTA_PROD_POST"/>
	 <WorkEffortType description="LinkedIN Product Post" hasTable="N" parentTypeId="SOCIAL_MEDIA_POST" workEffortTypeId="LINK_PROD_POST"/>
	 <WorkEffortType description="Facebook Article Post" hasTable="N" parentTypeId="SOCIAL_MEDIA_POST" workEffortTypeId="FACEB_ART_POST"/>
	 <WorkEffortType description="X(Twitter) Article Post" hasTable="N" parentTypeId="SOCIAL_MEDIA_POST" workEffortTypeId="X_ART_POST"/>
	 <WorkEffortType description="Instagram Article Post" hasTable="N" parentTypeId="SOCIAL_MEDIA_POST" workEffortTypeId="INSTA_ART_POST"/>
	 <WorkEffortType description="LinkedIN Article Post" hasTable="N" parentTypeId="SOCIAL_MEDIA_POST" workEffortTypeId="LINK_ART_POST"/>
 */

[
  {
      "WorkEffortId": "5c48be9e-edc8-4576-a"
  },
  {
      "workEffortTypeId": "SOCIAL_MEDIA_POST"
  },
  {
      "description": ""
  },
  {
      "estimatedStartDate": "2025-03-03 07:27:09.000"
  },
  {
      "workEffortPurposeTypeId": "FACEB_PROD_POST"
  },
  {
      "contentId": "a4fa4e02-dd6a-4d40-a"
  },
  {
      "contentName": ""
  },
  {
      "contentTypeId": "DOCUMENT"
  },
  {
      "productId": "GZ-1000"
  },
  {
      "productName": "Tiny Gizmo"
  },
  {
      "metaDataPredicateId": "FACEB_OG_TITLE"
  },
  {
      "metaDataValue": "Facebook Post Title for GZ-1000"
  },
  {
      "metaDataPredicateId1": "FACEB_OG_DESC"
  },
  {
      "metaDataValue1": "Facebook Description for GZ-1000"
  },
  {
      "metaDataPredicateId2": "FACEB_OG_IMAGE"
  },
  {
      "metaDataValue2": "https://cdn.example.com/GZ-1000-fb.jpg"
  }
]

@Component({
  selector: 'ubs-calendar-container',
  standalone: true,
  imports: [CommonModule, RouterOutlet,FullCalendarModule,NbCardModule, NbInputModule, NbButtonModule],
  templateUrl: './calendar-container.component.html',
  styleUrls: ['./calendar-container.component.scss']
})
export class CalendarContainerComponent implements OnInit{
  
  @Input() responseData: any;
  baseUrl:string;
  parsedUrl:any;
  objectInfo:string;
  imageBaseUrl:string;
  imageUrl:string;
  
  calendarOptions: CalendarOptions = {
    initialView: 'dayGridMonth',
    plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
    dateClick: (arg) => this.handleDateClick(arg),
    events:[],
    //eventContent: this.customEventContent.bind(this),
    eventClick: this.handleEventClick.bind(this)
    /* events(arg, successCallback, failureCallback) {
      console.log(arg);
      successCallback(this.formatEvents(arg));
      successCallback([
        { title: 'event 1', date: '2021-06-01' },
        { title: 'event 2', date: '2021-06-02' },
      ]);
    }, */
  };

  constructor(
    private dialogService: NbDialogService,
    private viewContainerRef: ViewContainerRef,
    private configServices:ConfigurationService
  ) {
    this.baseUrl = this.configServices.baseUrl;
    this.parsedUrl = new URL(this.baseUrl);
    this.imageBaseUrl = `${this.parsedUrl.protocol}//${this.parsedUrl.hostname}${this.parsedUrl.port ? `:${this.parsedUrl.port}` : ''}`;
    console.log(this.imageBaseUrl);
  }
  

  ngOnInit(): void {
    console.log(this.responseData);
    console.log(this.responseData.rows);
    if(this.responseData.rows){
      const rows = this.formatEvents(this.responseData.rows);
      console.log(rows);
      this.calendarOptions = {
        ...this.calendarOptions, // Preserve other options
        events: rows, // Update events
        eventContent: (arg) => this.customEventContent(arg), // Set dynamic event content
      };
    }
    //this.calendarOptions.events = this.responseData.rows;
  }

  handleDateClick(arg) {
    alert('date click bra! ' + arg.dateStr);
  
  }

  formatEvents(rows):any[]{
    //console.log(arg);
    console.log(rows);
    const flattenedObjects = rows.map(innerArray => {
      return innerArray.reduce((acc, obj) => {
        //acc.extendedProps = {};
        if ("estimatedStartDate" in obj) {
          acc.estimatedStartDate = obj.estimatedStartDate;
        }
        if ("metaDataValue" in obj) {
          acc.metaDataValue = obj.metaDataValue;
        }
        if ("workEffortPurposeTypeId" in obj) {
          acc.extendedProps = {
            ...acc.extendedProps,
            platform: obj.workEffortPurposeTypeId
          }
          //acc.extendedProps["platform"] = obj.workEffortPurposeTypeId;
        }
        if ("workEffortId" in obj) {
          acc.extendedProps = {
            ...acc.extendedProps,
            workEffortId: obj.workEffortId
          }
          //acc.extendedProps["workEffortId"] = obj.workEffortId;
        }
        if ("metaDataValue2" in obj) {
          acc.extendedProps = {
            ...acc.extendedProps,
            metaDataValue2: obj.metaDataValue2
          }
          //acc.extendedProps["metaDataValue2"] = obj.metaDataValue2;
        }
        return acc;
      }, {} as { estimatedStartDate?: string; metaDataValue?: string;extendedProps?:{platform?:string,workEffortId?:string,metaDataValue2?:string} });
    });

    return flattenedObjects.map(row => ({
      title: row.metaDataValue,
      date: row.estimatedStartDate,
      extendedProps:row.extendedProps
    }))
/*     return [
      { title: 'event 1', date: '2021-06-01' },
      { title: 'event 2', date: '2021-06-02' },
    ]; */
  }
  
  handleEventClick(info: any) {
    console.log('Event Clicked:', info.event);
    //alert(`Event: ${info.event.title}\nStart: ${info.event.start}`);

    const event = info.event;
    const platform = event.extendedProps.platform;
    const metaDataValue = event.extendedProps.metaDataValue;
    const metaDataValue2 = event.extendedProps.metaDataValue2;
    const workEffortId = event.extendedProps.workEffortId;
    const workEffortPurposeTypeId = platform;
    const title = event.title;
    const start = event.start;
    const baseUrl = this.imageBaseUrl;
    console.log(event.extendedProps)
    this.dialogService.open(CalendarDialogComponent, {
      context: {
        data:{
          workEffortId,
          title,
          start,
          platform,
          metaDataValue,
          metaDataValue2,
          workEffortPurposeTypeId,
          baseUrl
        }
      }
    });
  }

  // Custom event rendering
  customEventContent(arg: any) {
    console.log('Arg:', arg.eventInfo);
    if (!arg.event || !arg.event.extendedProps) {
      return; // Ensure event and extendedProps exist to avoid errors
    }
    const platform = arg.event.extendedProps.platform; // Get platform type
    const iconName = this.getPlatformIcon(platform); // Get corresponding icon

    // Create icon dynamically using ViewContainerRef
    const componentRef = this.viewContainerRef.createComponent(NbIconComponent);

    // Set the icon's properties
    componentRef.instance.icon = iconName;
    componentRef.instance.pack = 'eva';

    /* const iconElement = document.createElement('nb-icon');
    iconElement.setAttribute('icon', iconUrl);
    iconElement.setAttribute('pack', 'eva'); // Use Eva icons (default Nebular pack) */

    const wrapper = document.createElement('div');
    wrapper.style.display = 'flex';
    wrapper.style.alignItems = 'center';

     // Append Angular component
  const iconElement = componentRef.location.nativeElement;
  wrapper.appendChild(iconElement);
  wrapper.appendChild(document.createTextNode(` ${arg.event.title}`));

  return { domNodes: [wrapper] };

    /* return {
      html: `
        <div style="display: flex; align-items: center;">
          <nb-icon icon="${iconUrl}" style="margin-right: 5px;"></nb-icon>
          <img src="${iconUrl}" alt="${platform}" style="width: 16px; height: 16px; margin-right: 5px;">
          <span>${eventInfo.event.title}</span>
        </div>
      `
    }; */
  }

  // Get icon URL based on platform type
  getPlatformIcon(platform: string): string {
    const iconMap: { [key: string]: string } = {
      FACEB_PROD_POST: 'facebook-outline',
      INSTA_PROD_POST: 'camera-outline',
      X_PROD_POST: 'twitter-outline',
      LINK_PROD_POST: 'linkedin-outline'
    };
    return iconMap[platform] || 'assets/icons/default.png';
  }

}
